import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <main id="main" className="grid min-h-screen place-items-center px-4">
      <div className="max-w-[560px]">
        <p className="font-mono text-sm text-accent">404</p>
        <h1 className="mt-4 text-4xl font-semibold">Страница не найдена</h1>
        <p className="mt-4 text-lg text-muted">
          Возможно, в адресе опечатка или страницу убрали. Главная на месте, оттуда можно начать заново.
        </p>
        <Link to="/" className="btn mt-8" data-testid="notfound-home">
          Вернуться на главную
        </Link>
        <p className="mt-8 text-sm text-muted">
          Если ссылка, по которой ты пришёл, не открылась, напиши мне в Telegram:{" "}
          <a href="https://t.me/d_evoluer" target="_blank" rel="noopener noreferrer" className="text-white underline underline-offset-4">
            @d_evoluer
          </a>
          .
        </p>
      </div>
    </main>
  );
}
